var BLACKOUT_DAYS = []
var LOCATIONS = []
var PICKUP_ENABLED = false
var SHIPPING_ENABLED = false
$(document).ready(function () {
  processStuff()
  $('.Quantity-product__input').on('change', function () {
    var myInput = $(this);
    let minQtyTag = window.currentProduct.tags.find(tag => tag.includes('FB-MIN-'))
    if (!minQtyTag) return;
    let minQty = minQtyTag.replace('FB-MIN-', '')
    console.log('CurVal: ', myInput.val());
    
    if (parseInt(myInput.val()) < minQty) {
      myInput.val(minQty);
      console.log('minQty: ', minQty);
    }
  });
});
async function processStuff() {

  let baseUrl = 'https://freedom-bakery-custom-shipping-app.freedombakery.com'
  if (localStorage.getItem('dev_mode') == 1) {
    baseUrl = 'http://localhost:3000'
  }
  try {
    const data = await $.ajax({
      url: `${baseUrl}/api/get-product-settings-frontend?product_type=${window.currentProduct.type}&shop=${Shopify.shop}`,
      type: 'GET'
    }); 
    LOCATIONS = data.locations
    BLACKOUT_DAYS = data.blackouts.filter(rec => rec.active)
    PICKUP_ENABLED = data.pickupEnabled
    SHIPPING_ENABLED = data.shippingEnabled
  } catch (ex) {

  }
  //   $("input#Quantity-product-template").change(function () {
  //     let qty = $(this).val();
  //     let changeVal = $('select[data-index="option1"]')
  //       .find("option")
  //       .attr("value");

  //     $('select[data-index="option1"]')
  //       .find("option")
  //       .each(function (e) {
  //         let v = $(this).attr("value");
  //         let changeoption;
  //         if (v.includes("+")) {
  //           let NumberValue = parseInt(v.match(/\d+/)[0]);

  //           if (qty >= NumberValue) {
  //             changeVal = v;
  //           }
  //         }
  //       });
  //     $('select[data-index="option1"]').val(changeVal).change();
  //   });

  var TagRegex = /PFB-(B|C)-(\d\d:\d\d)-(\d{1,2})+-?(P|S)?/;
  if (!productTags) {
    return;
  }

  let PFBTags = productTags.filter(e => e.includes("PFB"));
  let currentTime = moment().valueOf();
  let currentDate = moment().format("YYYY-MM-DD");
  let FourPmCuttOff = moment(`${currentDate} 16:00`);
  let ElevenAmCuttOff = moment(`${currentDate} 11:00`);

  let pickupTags = PFBTags.filter(e => e.includes("-P"));
  let ShippingTags = PFBTags.filter(e => e.includes("-S"));
  let ShipDates = [],
    PickUpDates = [];
  let ShipDate,
    PickUpDate,
    finalCutoff,
    orderByTime,
    orderByDay,
    ShipDateText,
    PickUpDateText;

  if (PFBTags && PFBTags.length > 0) {
    PFBTags.forEach(tag => {
      let c = TagRegex.exec(tag);
      if (c) {
        let date = moment();

      
        let type = c[1],
          cutOffTime = c[2],
          productionDays = c[3],
          fulfillmentType = c[4];
          if (type == "B") {
            if (moment().day() == 6 || moment().day() == 0) {
            date = buildNextValidDate()
            }
          } 

        if (fulfillmentType && fulfillmentType.includes("S")) {
          if (type == "B") {
            date = date.businessAdd(productionDays, "days");
          } else {
            date = date.add(productionDays, "days");
          }
        } else {
          if (type == "B") {
            let tempDate = moment(date)
            tempDate = tempDate.add(productionDays, "days");
            if (tempDate.day() != 6) {
              if (date.day() == 5 && date.businessAdd(productionDays, "days").day() == 1) {
                tempDate = date.businessAdd(productionDays - 1, "days");
                tempDate = tempDate.add(1, "days");
              } else {
                tempDate = date.businessAdd(productionDays, "days");
              }
              //tempDate = date.businessAdd(productionDays, "days");
            }
            date = tempDate
          } else {
            date = date.add(productionDays, "days");
          }
        }

        if (fulfillmentType && fulfillmentType.includes("S")) {
          // //date = (type == "B") ? date.businessAdd(1, "days") : date.add(1, "days");
          let daysToAdd = 1
          // if (date.day() == 6 || date.day() == 0) {
          //   daysToAdd = type == "B" ? daysToAdd + 1 : daysToAdd + 2
          // }
          // if (date.day() == 5) {
          //   daysToAdd = daysToAdd + 2
          // }
          // date = (type == "B") ? date.businessAdd(daysToAdd, "days") : date.add(daysToAdd, "days");
          date = date.businessAdd(daysToAdd, "days")
          ShipDates.push({
            cutOffTime,
            date,
            type
          });
        }
        if (fulfillmentType && fulfillmentType.includes("P")) {
          PickUpDates.push({
            cutOffTime,
            date,
            type
          });
        }
      }
    });
  }


  let pickup_days_type = null
  let shipping_days_type = null

  if (PickUpDates.length > 0) {
    PickUpDates = PickUpDates.sort(function (lhs, rhs) {
      return lhs.date > rhs.date ? 1 : lhs.date < rhs.date ? -1 : 0;
    });
    PickUpDate = PickUpDates[0].date
    pickup_days_type = PickUpDates[0].type
    if (!finalCutoff) {
      finalCutoff = moment(`${currentDate} ${PickUpDates[0].cutOffTime}`);
    }
  }
  if (ShipDates.length > 0) {
    ShipDates = ShipDates.sort(function (lhs, rhs) {
      return lhs.date > rhs.date ? 1 : lhs.date < rhs.date ? -1 : 0;
    });
    ShipDate = ShipDates[0].date
    shipping_days_type = ShipDates[0].type
    if (!finalCutoff) {
      finalCutoff = moment(`${currentDate} ${ShipDates[0].cutOffTime}`);
    }
  }
  let afterCutoff = finalCutoff  && finalCutoff.valueOf && currentTime >= finalCutoff.valueOf(); 
  if (!afterCutoff && shipping_days_type != 'B' && ShipDate && ShipDate.day() == 1) {
    ShipDate = ShipDate.add(1, 'd')
  }
  if (finalCutoff && afterCutoff) {
    if (finalCutoff) finalCutoff = finalCutoff.add(1, "day");
    if (moment().day() != 6 && moment().day() != 0) {
      if (ShipDate) ShipDate = ShipDate.businessAdd(1, "day");
      if (PickUpDate) PickUpDate = PickUpDate.day() == 6 ? PickUpDate.businessAdd(2, "day") : PickUpDate.add(1, "day");
    }
  }
 
  ShipDate = processBlackoutDays(ShipDate, 'S', shipping_days_type, afterCutoff)
  // PickUpDate = processBlackoutDays(PickUpDate, 'P', pickup_days_type, afterCutoff)
 
  //PickUpDates.forEach(p => {
  //  let cutoffTime = moment(`${currentDate} ${p.cutOffTime}`);

  //  if (cutoffTime.valueOf() > currentTime && !PickUpDate) {
  //    PickUpDate = p.date;
  //    finalCutoff = cutoffTime;
  //    return;
  //  } else if (currentTime >= FourPmCuttOff.valueOf()) {
  //    PickUpDate = p.date.add(1, "day");
  //    let TodayCut = moment(`${currentDate} 11:00`);
  //    finalCutoff = TodayCut.add(1, "day");
  //  }
  //});

  //ShipDates.forEach(p => {
  //  let cutoffTime = moment(`${currentDate} ${p.cutOffTime}`);
  //  if (cutoffTime.valueOf() > currentTime && !ShipDate) {
  //    ShipDate = p.date;
  //    finalCutoff = cutoffTime;
  //    return;
  //  } else if (currentTime >= FourPmCuttOff.valueOf()) {
  //    ShipDate = p.date.add(1, "day");
  //    let TodayCut = moment(`${currentDate} 11:00`);
  //    finalCutoff = TodayCut.add(1, "day");
  //  }
  //});

  if (SHIPPING_ENABLED && ShipDate) {
    ShipDateText = ShipDate.format("ddd MM/DD");
    $(".recieve-by .date").text(ShipDateText);
  } else {
    $(".recieve-by").removeClass('d-flex').addClass('d-none');
  } 
  if (PICKUP_ENABLED && PickUpDate) {
    let pickdate = PickUpDate.format("YYYY-MM-DD");
    let earliestPickupByLocations = getEarliestPickupTime(PickUpDate,pickup_days_type,afterCutoff)
    let pickUP_HTML=``;

    for(let loc of earliestPickupByLocations){
      let time = loc.time.format('ddd MM/DD');  
      pickUP_HTML+=`<div class="pickup-by-location d-flex">
      <img src="//www.freedombakery.com/cdn/shop/t/62/assets/store-pick-up.svg?v=146216183083514683341727653456" class="pr-2" alt="">
      <span class="dark-brown pr-1"><b class="pickup-location location">${loc.location.company_name}</b> as soon as
        <span class="dark-grey bold date">${time}</span>
      </span>
    </div>`
    }


    // pickdate = moment(`${pickdate} ${earliestPickupTime || '09:00'}`);
    // var dateString = moment(pickdate).format('ddd MM/DD');
// console.log(`dateString`, dateString);

    // PickUpDateText = pickdate.calendar();
    if(earliestPickupByLocations.length>0){
    $(".pickup-by").html(`<div>`+pickUP_HTML+`</div>`);
    } 
    else{
      $(".pickup-by").removeClass('d-flex').addClass('d-none');
    } 
    //  let pickUpLocation = LOCATIONS?.[0]?.company_name;
    // if(pickUpLocation){
      // $(".pickup-by .location").text(pickUpLocation);
    // } 
    
  } else {
    $(".pickup-by").removeClass('d-flex').addClass('d-none');
  }

  if (finalCutoff) {
    finalCutoff = finalCutoff.calendar();
    finalCutoff = finalCutoff.replace("at", " ");

    $(".order-by-day .datetime").text(finalCutoff);
  } else {
    $(".delivery-details").removeClass('d-flex').addClass('d-none');
  }
  if (!SHIPPING_ENABLED && !PICKUP_ENABLED) {
    $(".delivery-details").removeClass('d-flex').addClass('d-none');
  }
  console.log({
    PFBTags,
    moment: moment(),
    ShipDates,
    PickUpDates,
    ShipDate,
    ElevenAmCuttOff,
    PickUpDate,
    ShipDateText,
    PickUpDateText,
    finalCutoff
  });
  // ;
}

function processBlackoutDays(date, fulfillmentType, days_type, afterCutoff,locationId) {
  // calculate blackout days between today and the date
  let today = moment()

  let sortedBlackoutDays = BLACKOUT_DAYS.sort(function (lhs, rhs) {
    return lhs.date > rhs.date ? 1 : lhs.date < rhs.date ? -1 : 0;
  });
  sortedBlackoutDays.forEach(day => {
    let totalBlackoutDays = 0
    if ((!afterCutoff && moment(day.date).isSame(today, 'date')) || moment(day.date).isBetween(today, date) || moment(day.date).isSame(date, 'date')) {
      let fullBlackOut = true
      if (days_type && days_type == 'B' && day.productionDays && day.productionDays.includes("business") && moment(day.date).day() != 6 && moment(day.date).day() != 0) {
        totalBlackoutDays++;
      } else if (days_type && days_type != 'B' && day.productionDays && day.productionDays.includes("calendar")) {
        if (fulfillmentType.includes("P")) {
          totalBlackoutDays++;
        } else if (moment(day.date).day() != 6 && moment(day.date).day() != 0) {
          totalBlackoutDays++;
        }
      } else if (fulfillmentType.includes("P")) {
        for (let [key, value] of Object.entries(day.pickupLocations)) {
          if (value.Availability.includes('part-time')) {
            fullBlackOut = false
          }
        }
        if (fullBlackOut && day.productionDays && !day.productionDays.includes("calendar")) {
          totalBlackoutDays++;
        }
      }
    }
    // add number of days
    if (totalBlackoutDays > 0) {
      if (fulfillmentType.includes("S")) {
        date = date.businessAdd(totalBlackoutDays, 'days')
      } else {
        if (moment(day.date).day() != 6 && moment(day.date).day() != 0) {
          let tempDate = moment(date)
          tempDate = tempDate.add(totalBlackoutDays, "days");
          if (tempDate.day() != 6) {
            tempDate = date.businessAdd(totalBlackoutDays, "days");
          }
          date = tempDate
          //date = date.businessAdd(totalBlackoutDays, 'days')
        } else {
          date = date.add(totalBlackoutDays, 'days')
        }
      }
    }
  })

  sortedBlackoutDays.forEach(day => {
    let shippingDate = moment(date).businessSubtract(1, "days")
    let totalBlackoutDays = 0
    if (day.ups_ship_day && fulfillmentType.includes("S") && moment(day.date).day() != 6 && moment(day.date).day() != 0 && (moment(day.date).isSame(date, 'date') || moment(day.date).isSame(shippingDate, 'date'))) {
      console.log('here');
      totalBlackoutDays++;
    }
    // add number of days
    if (totalBlackoutDays > 0) {
      date = (fulfillmentType.includes("S")) ? date.businessAdd(totalBlackoutDays, 'days') : date.add(totalBlackoutDays, 'days')
    }
  }) 
  return date
}

// function getEarliestPickupTime(date) {
//   let pickupDay = moment(date).format('dddd').toLowerCase()
//   let times = []
//   LOCATIONS.forEach(loc => {
//     times.push(moment(`${date.format("YYYY-MM-DD")} ${loc.pickup_time[pickupDay].start_time}`))
//   })

//   let isBlackOutDay = null
//   BLACKOUT_DAYS.forEach(day => {
//     if (moment(day.date).isSame(moment(date), 'date')) {
//       isBlackOutDay = day
//     }
//   })
//   if (isBlackOutDay) {
//     times = []
//     for (let [key, value] of Object.entries(isBlackOutDay.pickupLocations)) {
//       let confirmLocation = LOCATIONS.find(loc => loc.id == key)
//       if (value.Availability.includes('part-time') && confirmLocation) {
//         times.push(moment(`${date.format("YYYY-MM-DD")} ${value.StartTime}`))
//       }
//     }
//   }
//   //times = times.sort(function (lhs, rhs) { return lhs < rhs ? 1 : lhs > rhs ? -1 : 0; });
//   times = times.sort(function (lhs, rhs) {
//     return lhs > rhs ? 1 : lhs < rhs ? -1 : 0;
//   });
//   let earliest = times.length > 0 ? times[0].format('HH:mm') : null
//   return earliest
// }
function getNextClosestDay(inputDay, dayArray) {
  // Convert inputDay to a moment object
  const inputMoment = moment(inputDay, 'dddd'); // 'dddd' format for full weekday name
  
  // Convert all the days in the array to moment objects and calculate the difference
  const closestDay = dayArray
    .map(day => ({
      name: day,
      diff: moment(day, 'dddd').diff(inputMoment, 'days')
    }))
    // Filter out days in the past and sort by the closest future day
    .filter(day => day.diff >= 0)
    .sort((a, b) => a.diff - b.diff);
  
  // If there's a valid closest day, return its name, otherwise return the first available
  return closestDay.length ? closestDay[0].name : dayArray[0];
}
function getNextDateForWeekday(currentMoment, weekdayName) {
  // Get the current day of the week index (0 for Sunday, 1 for Monday, etc.)
  const currentDayIndex = currentMoment.day();
  
  // Get the target day index for the provided weekday name
  const targetDayIndex = moment().day(weekdayName).day();
  
  // Calculate how many days to add to reach the target day
  const dayDifference = (targetDayIndex - currentDayIndex + 7) % 7;

  // If the dayDifference is 0, it means the provided weekday is today,
  // so return today, otherwise, return the next occurrence.
  return dayDifference === 0
    ? currentMoment
    : currentMoment.clone().add(dayDifference, 'days');
}

// function getEarliestPickupTime(date,pickup_days_type,afterCutoff) {
//   let pickupDayname = moment(date).format('dddd').toLowerCase();
//   let earliestTimes = {};

//   // Initialize earliest times per location based on their regular schedule
//   LOCATIONS.forEach(loc => {
//     let locId = loc.id; 
//     // let pickupDay = getNextClosestDay(pickupDayname, loc.pickup_days);
//     let locpickupTime = moment(loc?.dates[0]?.pickup_time) || null;
//     let pickupDay = locpickupTime.format('dddd').toLowerCase(); 
//     let pickupTime = moment(`${locpickupTime.format("YYYY-MM-DD")} ${loc.pickup_time[pickupDay].start_time}`); 
//    // let PickUpDate = processBlackoutDays(pickupTime, 'P', pickup_days_type, afterCutoff,locId)
//     //  let pickupTime= moment(date) || null;
   
//     earliestTimes[locId] = {
//       location: loc,
//       pickupTime,
//       time: pickupTime
//     };
//   });

//   // Check if the date is a blackout day
//   let isBlackOutDay = null;
//   BLACKOUT_DAYS.forEach(day => {
//     if (moment(day.date).isSame(moment(date), 'date')) {
//       isBlackOutDay = day;
//     }
//   });

//   if (isBlackOutDay) {
//     // Adjust earliest times based on blackout day information
//     for (let locId in earliestTimes) {
//       let blackoutInfo = isBlackOutDay.pickupLocations[locId];
//       if (blackoutInfo) {
//         if (blackoutInfo.Availability.includes('part-time')) {
//           // Adjust start time for part-time availability
//           let adjustedTime = moment(`${date.format("YYYY-MM-DD")} ${blackoutInfo.StartTime}`);
//           earliestTimes[locId].time = adjustedTime;
//         } else if (blackoutInfo.Availability.includes('full')) {
//           // Full availability, no change needed
//           continue;
//         } else {
//           // Location is not available, remove it
//           delete earliestTimes[locId];
//         }
//       } else {
//         // Location not specified in blackout, assume not available
//         delete earliestTimes[locId];
//       }
//     }
//   }

//   // Format the times and prepare the result
//   let result = {};
//   for (let locId in earliestTimes) {
//     let time = earliestTimes[locId].time.format('HH:mm');
//     result[locId] = time;
//   }

//   let finalResults=Object.values(earliestTimes)
//   finalResults = finalResults.filter(rec => rec.location.order_by_box==1);
//   // for(let [key,value] of Object.entries(result)){
    
//   //   finalResults.push({
//   //     location: LOCATIONS.find(loc => loc.id == key),
//   //     location_id: key,
//   //     time: value
//   //   })
//   // } 

//   return finalResults; // Returns an object with locId as key and earliest pickup time as value
// } 

function getEarliestPickupTime(date,pickup_days_type,afterCutoff) {
  let pickupDayname = moment(date).format('dddd').toLowerCase();
  let earliestTimes = {};

  // Initialize earliest times per location based on their regular schedule
  LOCATIONS.forEach(loc => {
    let locId = loc.id; 
    // let pickupDay = getNextClosestDay(pickupDayname, loc.pickup_days);
    let locpickupTime = loc?.dates[0]?.date ? moment(loc?.dates[0]?.date) : null;
    let pickupDay = locpickupTime.format('dddd').toLowerCase(); 
    let pickupTime = moment(`${locpickupTime.format("YYYY-MM-DD")} ${loc.pickup_time[pickupDay].start_time}`); 
   // let PickUpDate = processBlackoutDays(pickupTime, 'P', pickup_days_type, afterCutoff,locId)
    //  let pickupTime= moment(date) || null;
    if(loc.dates && loc.dates.length>0){
    earliestTimes[locId] = {
      location: loc,
      pickupTime,
      time: pickupTime
    }; 
    }
  });

 
 

  let finalResults=Object.values(earliestTimes)
  finalResults = finalResults.filter(rec => rec.location.order_by_box==1);
  // for(let [key,value] of Object.entries(result)){
    
  //   finalResults.push({
  //     location: LOCATIONS.find(loc => loc.id == key),
  //     location_id: key,
  //     time: value
  //   })
  // } 

  return finalResults; // Returns an object with locId as key and earliest pickup time as value
} 


function buildNextValidDate() {
  let dayIncrement = 2;  // from 1 
  
  if (moment().day() === 6) {
    // set to monday
    dayIncrement = 2;   //from 2
  }  
    
  return moment().add(dayIncrement, 'd');
}